import { AccountCircle, ArrowForwardIos } from "@mui/icons-material";
import { AlertColor, Box, Checkbox, Grid, Link } from "@mui/material";
import { KeyDriveh4Header } from "../../../../../components/KeydriveComponents/Fonts/Headers/KeyDriveh4Header";
import { KeyDriveBodyMin } from "../../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { KeydriveTextfield } from "../../../../../components/KeydriveComponents/Textfield/KeydriveTextfield";
import KeyDriveWordDivider from "../../../../../components/KeydriveComponents/Dividers/KeydriveOrDivider";
import CustomButton from "../../../Login/CustomButton";
import { KeyDrivePrimaryButton } from "../../../../../components/KeydriveComponents/Buttons/KeyDrivePrimaryButton";
import { KeyDriveBodyMax } from "../../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMax";
import { IRegisterUserObject } from "../../Register";
import { useTranslation } from "react-i18next";
import microsoftIcon from '../../../../../assets/icons/Microsoft_logo_(2012).svg';
import Iconborder from "../IconBorder";

interface IRegisterAccount {
    createUserObject: IRegisterUserObject;
    usernameHandler: (e: string) => void;
    emailHandler: (e: string) => void;
    forwardStep: () => void;
    backStep: () => void;
    setAlertColor: (set: AlertColor) => void;
    setMessage: (set: string) => void;
    setSendEmailOk: (set: boolean) => void;
    setPrivacyOk: (set: boolean) => void;
    emailOk: boolean;
    privacyOk: boolean;
    emailOkHandler: (set: boolean) => void;
    privacyOkHandler: (set: boolean) => void;
    setCreateUserObject: (set: IRegisterUserObject) => void;
}


export default function RegisterAccount({
    createUserObject,
    emailHandler,
    usernameHandler,
    backStep,
    forwardStep,
    setAlertColor,
    setMessage,
    setPrivacyOk,
    setSendEmailOk,
    emailOk,
    privacyOk,
    emailOkHandler,
    privacyOkHandler,
    setCreateUserObject
}: IRegisterAccount): JSX.Element {


    console.log(createUserObject)

    const { t } = useTranslation();

    return (
        <>
            <Grid item xs={12} display="flex" justifyContent="center" marginBottom="12px">
                <Iconborder>
                    <AccountCircle sx={{ color: "#22638D", width: "36px", height: "36px" }} />
                </Iconborder>
            </Grid>
            <Grid item xs={12} textAlign="center" marginBottom="32px">
                <KeyDriveh4Header
                    color={"#22638D"}
                    needBold
                    needEllipses={false}
                    text={t("RegisterPage.steps.step1.title")}
                    sxStyles={{
                        marginBottom: "12px"
                    }}
                />
                <KeyDriveBodyMin
                    color="#7AA1BB"
                    needBold={false}
                    needEllipses={false}
                    text={t("RegisterPage.steps.step1.content")}
                />
            </Grid>
            <Grid item xs={12} display="flex" justifyContent="space-between" marginTop="12px">
                <KeydriveTextfield 
                    label={t("Register.Username")}
                    onChange={e => usernameHandler(e.target.value)}
                    value={createUserObject.username}
                    placeholder={t("Register.TypeHere")}
                    needFullWidth
                    required
                />
            </Grid>
            <Grid item xs={12} textAlign="center">
                <KeydriveTextfield 
                    label={t("Register.Email")}
                    onChange={e => emailHandler(e.target.value)}
                    value={createUserObject.email}
                    placeholder={t("Register.TypeHere")}
                    needFullWidth
                    type="email"
                    required
                />
            </Grid>
            <Grid item xs={12} display="flex" flexDirection="column" justifyContent="center" marginTop="20px">
                <Box display="flex" justifyContent="start" alignItems="center">
                    <Checkbox 
                        onChange={e => {
                            if (e.currentTarget.checked) {
                                setCreateUserObject({
                                    ...createUserObject,
                                    privacyOk: true
                                })
                            } else {
                                setCreateUserObject({
                                    ...createUserObject,
                                    privacyOk: false
                                })
                            }
                        }}
                        value={createUserObject.privacyOk}
                        checked={createUserObject.privacyOk}
                    />
                    <KeyDriveBodyMin 
                        color="#000"
                        needBold={false}
                        needEllipses={false}
                        text={t("Register.IamOkPrivacy")}
                    />
                </Box>
                <Box display="flex" justifyContent="start" alignItems="center">
                    <Checkbox 
                        onChange={e => {
                            if (e.currentTarget.checked) {
                                setCreateUserObject({
                                    ...createUserObject,
                                    emailOk: true
                                })
                            } else {
                                setCreateUserObject({
                                    ...createUserObject,
                                    emailOk: false
                                })
                            }
                        }}
                        value={createUserObject.emailOk}
                        checked={createUserObject.emailOk}
                    />
                    <KeyDriveBodyMin 
                        color="#000"
                        needBold={false}
                        needEllipses={false}
                        text={t("Register.WantSendingEmail")}
                    />
                </Box>
            </Grid>
            <Grid item xs={12} marginTop="20px">
                <KeyDrivePrimaryButton 
                    TextComponent={KeyDriveBodyMax}
                    TextComponentProps={{
                        color: "white",
                        needBold: true,
                        needEllipses: false,
                        text: "Avançar"
                    }}
                    endIcon={<ArrowForwardIos />}
                    needFullWidth
                    onClick={() => {
                        if (createUserObject.username == "" || createUserObject.email == "") {
                            setMessage(t("Register.FirstPageError"));
                            setAlertColor("error");
                            throw new Error("Campos devem ser preenchidos de maneira correta.");
                        }

                        if (!createUserObject.privacyOk) {
                            setMessage(t("Register.BeOkWithBoth"));
                            setAlertColor("error");
                            throw new Error("Campos devem ser preenchidos de maneira correta.");
                        } 
                        
                        if (!createUserObject.emailOk) {
                            setMessage(t("Register.BeOkWithBoth"));
                            setAlertColor("error");
                            throw new Error("Campos devem ser preenchidos de maneira correta.");
                        }
                        
                        forwardStep();
                    }}
                />
            </Grid>
            <Grid item xs={12} display="flex" justifyContent="center" marginTop="20px">
                <KeyDriveBodyMin 
                    text={t("Register.AlreadyHaveAccount")}
                    color="#2D2D2D"
                    needBold={false}
                    needEllipses={false}
                    sxStyles={{
                        marginRight: "4px"
                    }}
                />
                <Link sx={{
                    marginLeft: "4px"
                }} href="/login">
                    {t("Register.BackToLogin")}
                </Link>
            </Grid>
        </>
    )
}